// extracted by mini-css-extract-plugin
export default {"layout":"jYyb2"};